<div class="p-6 flex flex-col gap-4 bg-white rounded-2xl">
      <div class="flex items-center gap-3 text-red-500">
        <div class="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center">
          <i class="fi fi-rr-trash text-xl flex"></i>
        </div>
        <h2 class="text-xl font-semibold text-gray-800">Confirmar eliminación</h2>
      </div>
      
      <p class="text-gray-600 mt-2">
        ¿Estás seguro que deseas eliminar el pedido en borrador <strong class="text-gray-900">{{ data.identifier }}</strong>? Esta acción no se puede deshacer.
      </p>
      
      <div class="flex justify-end gap-3 mt-6">
        <button 
          class="px-5 py-2.5 text-sm font-medium text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-xl cursor-pointer transition-colors" 
          (click)="close(false)">
          Cancelar
        </button>
        <button 
          class="px-5 py-2.5 text-sm font-medium text-white bg-red-500 hover:bg-red-600 rounded-xl cursor-pointer transition-colors shadow-sm" 
          (click)="close(true)">
          Sí, eliminar
        </button>
      </div>
    </div>